export default function selectCompetencyDisplayInfo(competency) {
  const { champ, overrideImage, with: subtitleText = "" } = competency;

  let competencyImage;
  let backgroundColor;
  let subtitle = subtitleText;

  if (champ) {
    const champImages = champ.images?.phase2;
    competencyImage = {
      "regular@1x": champImages.headshot["1x"],
      "regular@2x": champImages.headshot["2x"],
      "regular@3x": champImages.headshot["3x"],
    };
    backgroundColor = champ.primaryColor;
    subtitle = subtitle || champ.name;
  } else {
    competencyImage = overrideImage;
    backgroundColor = "transparent";
  }
  return {
    backgroundColor,
    competencyImage,
    subtitle,
  };
}
